<app-service-request-code-picker [typeOfService]="null" [mustChooseFromOptions]="true"
    (selectionChange)="onServicePickerChange($event)">
</app-service-request-code-picker>